import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface ModeDto {
  id: string;
  key: string;
  displayName: string;
  defaultRoute: string;
}

export interface ResolvedModes {
  availableModes: ModeDto[];
  defaultMode: ModeDto;
}

@Injectable({ providedIn: 'root' })
export class ModeService {
  private readonly http = inject(HttpClient);
  private readonly STORAGE_KEY = 'activeMode';
  private readonly activeMode$ = new BehaviorSubject<ModeDto | null>(null);

  loadModes(): Observable<ResolvedModes> {
    const url = `${environment.apiBaseUrl}/api/v1/me/modes`;
    return this.http.get<ResolvedModes>(url);
  }

  setActiveMode(mode: ModeDto): void {
    try {
      sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(mode));
    } catch {
      /* sessionStorage no disponible */
    }
    this.activeMode$.next(mode);
  }

  getActiveMode$(): Observable<ModeDto | null> {
    return this.activeMode$.asObservable();
  }

  getActiveModeSnapshot(): ModeDto | null {
    const fromSubject = this.activeMode$.value;
    if (fromSubject) {
      return fromSubject;
    }
    try {
      const raw = sessionStorage.getItem(this.STORAGE_KEY);
      if (!raw) {
        return null;
      }
      return JSON.parse(raw) as ModeDto;
    } catch {
      return null;
    }
  }

  /** Hidrata el subject desde sessionStorage (p. ej. tras F5). */
  hydrateFromStorage(): void {
    const snap = this.getActiveModeSnapshot();
    if (snap) {
      this.activeMode$.next(snap);
    }
  }
}
